import PosthogService from '~/services/posthog/PosthogService';

export interface IPermValuePropGetStartedPayload {
  postingId: string;
}

/**
 * Fires when user clicks "Start Hiring" on the value proposition screen
 * Event: dental_portal:perm_post_job:value_prop_get_started
 */
export function firePermValuePropGetStarted(payload: IPermValuePropGetStartedPayload): void {
  PosthogService.getInstance().track('dental_portal:perm_post_job:value_prop_get_started', {
    posting_id: payload.postingId,
  });
}
